/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    zoom: {
        maxRatio: 2,
        minRation: 1
    },
    navigation: {
        nextEl: document.querySelector('#productVisualSwiperWrap .nextEl'),
        prevEl: document.querySelector('#productVisualSwiperWrap .prevEl'),
    },
    on: {
        slideChange: function () {
            // update the thumbnail active class
            document.querySelector(".productVisualThumbsSlide.active").classList.remove("active");
            document.querySelectorAll(".productVisualThumbsSlide")[this.realIndex].classList.add("active");

            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                element.pause();
            });
        }
    }
});

// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        if (!video) return;

        // remove play button if it hasn't already been removed
        this.querySelector(".productVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});


/****************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
})

// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productOptionItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Not Available";
        return;
    }

    // update price
    document.querySelector("#productPriceReal").textContent = price(activeVariant.price);
    document.querySelector("#productSubscriptionPriceReal").textContent = price(activeVariant.price);
    document.querySelector("#productSubscriptionPriceSubscribe").textContent = price(activeVariant.selling_plan_allocations[0].per_delivery_price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector("#productPriceReal").classList.add("sale");
        document.querySelector("#productPriceCompare").textContent = price(activeVariant.compare_at_price);
    } else {
        document.querySelector("#productPriceReal").classList.remove("sale");
        document.querySelector("#productPriceCompare").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").classList.add("primary");
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATC").textContent = "Add To Cart";
    } else {
        document.querySelector("#productATC").classList.remove("primary");
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "Sold Out";
    }

    // if variant has featured_image, slide to image
    if (activeVariant?.featured_image) {
        productSwiper.slideTo(activeVariant.featured_image.position - 1);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);

    // generate new subscription dropdown based on selling plan allocations
    let sellingPlanHTML = "";
    activeVariant.selling_plan_allocations.forEach((allocation) => {
        // find the selling plan based on the allocation.selling_plan_id
        let sellingPlan;
        for (let group of product.selling_plan_groups) {
            for (let plan of group.selling_plans) {
                if (plan.id === allocation.selling_plan_id) {
                    sellingPlan = plan;
                    break;
                }
            }
        }

        // create the option
        sellingPlanHTML += `<option value="${sellingPlan.id}">${sellingPlan.name.replace("Every ", "")}</option>`;
    });
    document.querySelector("#productSubscriptionSelect").innerHTML = sellingPlanHTML;

    // update shop-pay element variant id and display price
    document.querySelector("#productForm input[name='product-id']").value = activeVariant.id;
}

/*******************
 * Product Quantity
 *******************/


let quantity = 1;
const maxQuantity = document.querySelector('#productQuantity').dataset.maxQuantity;
const quantityMessage = document.querySelector('#quantityLimitMessage');
const incrementButton = document.querySelector('#productQuantityIncrement');
const decrementButton = document.querySelector('#productQuantityDecrement');

// updating quantity
document.querySelector('#productQuantityBody').addEventListener('click', function (e) {
    if (e.target.id === "productQuantityIncrement") {
        if (quantity < maxQuantity) {
            quantity++;
            quantityMessage.style.display = "none";
        } 
        if (quantity >= maxQuantity) {
            quantityMessage.style.display = "block";
        }
    } else if (e.target.id === "productQuantityDecrement") {
        if (quantity > 1) {
            quantity--;
            quantityMessage.style.display = "none";
        }
    }
    document.querySelector('#productQuantityAmount').textContent = quantity.toString();
    updateButtonStates();
});

function updateButtonStates() {
    incrementButton.disabled = quantity >= maxQuantity;
    decrementButton.disabled = quantity <= 1;
}


/*******************
 Product Subscription
 ********************/

const subscriptionSelect = document.querySelector('#productSubscriptionSelect');

// changing from OTP to Subscription
document.querySelectorAll('.productPurchaseOption').forEach(el => {
    el.addEventListener('click', function () {
        // handle active
        if (this.classList.contains('active')) return;
        this.closest('#productPurchase').querySelector('.productPurchaseOption.active').classList.remove('active');
        this.classList.add('active');
    })
})

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // add subscription to product
    if (document.querySelector("#productSubscription.active")) {
        formData.items[0].selling_plan = parseInt(document.querySelector("#productSubscriptionSelect").value)
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

/****************
 Image zooming
 ***************/
document.addEventListener('DOMContentLoaded', function () {
  const images = document.querySelectorAll('.productVisualSwiperSlideImage');

  
  images.forEach(image => {
    new Drift(image, {
      paneContainer: document.querySelector('#productContent'), // Or any other container for the zoomed image
      sourceAttribute: 'data-zoom', // Tells Drift where to find the zoomed image
      zoomFactor: 2,  // Adjust the zoom level if necessary
      showWhitespaceAtEdges: false,  // Optional, whether to show whitespace at the edges of the zoomed image
      hoverDelay: 50,  // Optional, time delay for showing the zoom pane on hover
      inlinePane: false

    });
  });
});